import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import Badge from 'components/Badge'
import styles from './ActivityCard.module.sass'

const LazyLoadImage = React.lazy(() =>
  import('react-lazy-load-image-component').then(module => ({
    default: module.LazyLoadImage
  }))
)

const ActivityCard = ({
  thumbnail,
  credit,
  creditType,
  publisher,
  publisherImg,
  date,
  title,
  authors,
  url,
  alt
}) => {
  return (
    <div className={styles.card}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline'
        }}
      >
        {publisher && (
          <Badge
            text={publisher}
            icon={publisherImg || require('images/abstract.png')}
          />
        )}
        {date && <p className={styles.credit}>{date}</p>}
        {creditType && creditType?.toUpperCase() !== 'IME' && (
          <p className={styles.credit}>
            {creditType?.toUpperCase() === 'EBAC-CE'
              ? `${creditType}`
              : `${credit} ${creditType}`}
          </p>
        )}
      </div>

      <div style={{ display: 'flex', marginTop: '10px' }}>
        <div>
          <a href={url} target="_blank" rel="noreferrer">
            <Suspense fallback={''}>
              <LazyLoadImage
                src={
                  thumbnail ||
                  'https://c.answersincme.com/assets/images/aicme-default-thumbnail.jpg'
                }
                className={styles.img}
                effect="opacity"
                alt={alt}
              />
            </Suspense>
          </a>
        </div>
        <div>
          <a href={url} target="_blank" rel="noreferrer">
            <p className={styles.title}>{title}</p>
          </a>
          <p className={styles.author} style={{ whiteSpace: 'pre' }}>
            {authors.join(`\n`)}
          </p>
        </div>
      </div>
    </div>
  )
}

ActivityCard.propTypes = {
  thumbnail: PropTypes.string,
  publisher: PropTypes.string,
  publisherImg: PropTypes.string,
  date: PropTypes.string,
  credit: PropTypes.string,
  creditType: PropTypes.string,
  title: PropTypes.string,
  authors: PropTypes.array,
  url: PropTypes.string,
  alt: PropTypes.string
}

export default ActivityCard
